(() => {
  const selector = '#SearchProductGrid [data-tc-search-results]';
  const getResults = (document) => document.querySelector(selector);
  const getCards = (results) => Array.from(results.querySelectorAll(':scope > .grid > .search-result, :scope > .list > .search-result'));
  const readHTML = (html) => new DOMParser().parseFromString(html, 'text/html');
  const canonicalize = (url) => {
    const canonical = url.searchParams.get('options') || '';
    const prefix = canonical.match(/["']prefix["']\s*(?:=>|:)\s*["']([^"']+)["']/);
    url.searchParams.delete('options');
    if (prefix && !url.searchParams.has('options[prefix]')) url.searchParams.set('options[prefix]', prefix[1]);
    url.searchParams.set('options[unavailable_products]', 'last');
    return url;
  };
  const fetchDocument = async (url) => {
    const response = await fetch(url.href, { cache: 'no-store' });
    if (!response.ok) throw new Error('Search request failed');
    const document = readHTML(await response.text());
    if (!getResults(document)) throw new Error('Search results missing');
    return document;
  };
  const prepare = async (html, requestURL) => {
    const document = readHTML(html);
    const results = getResults(document);
    if (!results || results.dataset.pageSize === '250') return html;
    const pageSize = Number(results.dataset.pageSize);
    const page = Number(results.dataset.page);
    const total = Number(results.dataset.count);
    if (!pageSize || !page || !total || page > Math.ceil(total / pageSize)) return html;
    const url = canonicalize(new URL(requestURL, window.location.origin));
    url.searchParams.delete('section_id');
    url.searchParams.set('view', 'inventory');
    url.searchParams.set('page', '1');
    const first = getResults(await fetchDocument(url));
    const batchSize = Number(first.dataset.pageSize);
    if (batchSize !== 250 || Number(first.dataset.count) !== total) throw new Error('Search changed; refresh required');
    const documents = [first];
    const pages = Math.ceil(total / batchSize);
    if (pages > 100) throw new Error('Search exceeds safe batch limit');
    let nextPage = 2;
    await Promise.all(Array.from({ length: Math.min(4, pages - 1) }, async () => {
      while (nextPage <= pages) {
        const currentPage = nextPage++;
        const pageURL = new URL(url);
        pageURL.searchParams.set('page', String(currentPage));
        const batch = getResults(await fetchDocument(pageURL));
        if (Number(batch.dataset.count) !== total || Number(batch.dataset.page) !== currentPage) throw new Error('Search changed; refresh required');
        documents[currentPage - 1] = batch;
      }
    }));
    const cards = documents.flatMap(getCards);
    if (cards.length !== total) throw new Error('Incomplete search results');
    const group = (card) => card.classList.contains('search-result-product')
      ? (card.dataset.available === 'true' ? 0 : 1) : 2;
    cards.sort((left, right) => group(left) - group(right));
    const offset = (page - 1) * pageSize;
    const pageCards = cards.slice(offset, offset + pageSize);
    if (!pageCards.length) throw new Error('Empty search page');
    const grid = results.querySelector(':scope > .grid, :scope > .list');
    if (!grid) throw new Error('Search grid missing');
    const separator = Array.from(grid.children).find((child) => !child.classList.contains('search-result'));
    grid.replaceChildren();
    pageCards.forEach((card, index) => {
      grid.append(document.importNode(card, true));
      if (grid.classList.contains('list') && separator && index < pageCards.length - 1) grid.append(separator.cloneNode(true));
    });
    results.dataset.inventorySorted = 'true';
    results.classList.remove('tc-inventory-loading');
    return document.documentElement.outerHTML;
  };
  window.addEventListener('click', (event) => {
    const link = event.target.closest && event.target.closest('#SearchProductGrid .pagination a[href]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const destination = new URL(link.href, window.location.origin);
    if (destination.origin !== window.location.origin) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(canonicalize(destination).href);
  }, true);
  window.TCSearchInventory = { prepare };
  const initialPage = async () => {
    const results = getResults(document);
    if (!results || results.dataset.pageSize === '250') return;
    results.classList.add('tc-inventory-loading');
    results.setAttribute('aria-busy', 'true');
    try {
      const html = await prepare(document.documentElement.outerHTML, window.location.href);
      if (!results.isConnected) return;
      const replacement = getResults(readHTML(html));
      const currentGrid = results.querySelector(':scope > .grid, :scope > .list');
      const replacementGrid = replacement && replacement.querySelector(':scope > .grid, :scope > .list');
      if (!currentGrid || !replacementGrid) throw new Error('Search grid missing');
      currentGrid.replaceWith(replacementGrid);
      results.dataset.inventorySorted = 'true';
      results.classList.remove('tc-inventory-loading');
    } catch {
      results.classList.remove('tc-inventory-loading');
    } finally {
      results.removeAttribute('aria-busy');
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialPage, { once: true });
  else initialPage();
})();
